import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'hbc_flash_sale_deadline';
const DURATION_MS = 15 * 60 * 1000; // 15 minutes
const getDeadline = (): number => {
  if (typeof window === 'undefined') return Date.now() + DURATION_MS;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = parseInt(stored, 10);
      if (!Number.isNaN(parsed) && parsed > Date.now()) return parsed;
    }
  } catch {
    /* ignore */
  }
  const fresh = Date.now() + DURATION_MS;
  try {
    window.localStorage.setItem(STORAGE_KEY, String(fresh));
  } catch {
    /* ignore */
  }
  return fresh;
};
const formatPart = (n: number) => String(Math.max(0, n)).padStart(2, '0');
export const AnnouncementBar = () => {
  const [remaining, setRemaining] = useState<number>(DURATION_MS);
  useEffect(() => {
    const deadline = getDeadline();
    const tick = () => {
      const diff = deadline - Date.now();
      setRemaining(diff > 0 ? diff : 0);
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);
  const totalSeconds = Math.floor(remaining / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return <div className="w-full" style={{
    background: 'linear-gradient(90deg, #2D1B4E 0%, #3D2566 50%, #2D1B4E 100%)',
    borderBottom: '1px solid rgba(224,187,228,0.18)'
  }} data-id="element-11">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-2 md:py-2.5 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-5" data-id="element-12">
        {/* Headline */}
        <div className="flex items-center gap-2 text-white text-center" data-id="element-13">
          <span style={{
          color: '#D4AF37',
          fontSize: '14px'
        }} data-id="element-14">
            ★
          </span>
          <p className="font-playfair m-0" style={{
          fontSize: 'clamp(13px, 1.4vw, 16px)',
          fontWeight: 700,
          letterSpacing: '0.01em',
          lineHeight: 1.2
        }} data-id="element-15">
            FLASH SALE:{' '}
            <span style={{
            color: '#E0BBE4',
            fontStyle: 'italic',
            fontWeight: 700
          }} data-id="element-16">
              50% OFF
            </span>{' '}
            the Hormonal Balance Bundle ends in:
          </p>
        </div>
        {/* Countdown */}
        <div className="flex items-center gap-1.5" aria-live="polite" aria-label={`Offer ends in ${formatPart(minutes)} minutes and ${formatPart(seconds)} seconds`} data-id="element-17">
          <TimeBox value={formatPart(minutes)} data-id="element-18" />
          <span className="font-montserrat text-white" style={{
          fontSize: '18px',
          fontWeight: 700,
          opacity: 0.7
        }} data-id="element-19">
            :
          </span>
          <TimeBox value={formatPart(seconds)} data-id="element-20" />
        </div>
        {/* CTA */}
        <a href="https://vitalyforms.com/cart/50255656976604:1" target="_blank" rel="noopener noreferrer" className="font-lato no-underline transition-colors duration-300" style={{
        color: '#2D1B4E',
        background: '#D4AF37',
        fontWeight: 700,
        fontSize: '12px',
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        padding: '8px 16px',
        borderRadius: '50px',
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 8px rgba(212,175,55,0.35)'
      }} onMouseEnter={e => {
        ;
        (e.currentTarget as HTMLAnchorElement).style.background = '#E6C24A';
      }} onMouseLeave={e => {
        ;
        (e.currentTarget as HTMLAnchorElement).style.background = '#D4AF37';
      }} data-id="element-21">
          Claim Offer Now →
        </a>
      </div>
    </div>;
};
type TimeBoxProps = {
  value: string;
};
const TimeBox = ({
  value
}: TimeBoxProps) => <div className="font-montserrat text-white flex items-center justify-center" style={{
  background: 'rgba(224,187,228,0.18)',
  border: '1px solid rgba(224,187,228,0.35)',
  borderRadius: '8px',
  minWidth: '40px',
  padding: '4px 8px',
  fontSize: '16px',
  fontWeight: 700,
  letterSpacing: '0.02em',
  fontVariantNumeric: 'tabular-nums'
}} data-id="element-22">
    {value}
  </div>;